


































































































import { anyToDate, formatDate } from 'vtils/date'
import {
  apiEvaluationEvaluateList,
  ApiEvaluationEvaluateListResponse,
  apiEvaluationEvaluateSubmitStrategyEvaluate,
  apiEvaluationEvaluateThumbsUpOrDown,
  ApiMallDocInfoStrategyDetailsResponse,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { isThisYear } from 'date-fns/esm'
import { requiredDeep, submit } from '@/utils'
import { RequiredDeep } from 'vtils/types'

export default defineClassComponent<{
  pid: string
  strategy: RequiredDeep<ApiMallDocInfoStrategyDetailsResponse>
  item: RequiredDeep<ApiEvaluationEvaluateListResponse>['list'][0]
  isChildren?: boolean
}>(
  {
    name: 'CommentItem',
    props: ['pid', 'strategy', 'item', 'isChildren'],
  },
  ({ props }) =>
    class {
      showCommentDialog = ref(false)

      commentContent = ref('')

      showChildCount = ref(1)

      hasMoreChild = computed(
        () => this.showChildCount.value < props.item.childList.length,
      )

      formatDate = (date: string) => {
        const d = anyToDate(date)
        return isThisYear(d)
          ? formatDate(d, 'mm-dd')
          : formatDate(d, 'yyyy-mm-dd')
      }

      handleMoreChildClick = () => {
        this.showChildCount.value += 5
      }

      handleCommentSendClick = () => {
        submit(async $ => {
          if (!this.commentContent.value) {
            return $.fail('请输入评论内容')
          }
          $.start()
          await apiEvaluationEvaluateSubmitStrategyEvaluate({
            commodityServiceId: props.strategy.id,
            commodityServiceName: props.strategy.title,
            evaluateContent: this.commentContent.value,
            parentEvaluateId: props.item.id,
          })
          const {
            list: [newParentComment],
          } = await apiEvaluationEvaluateList({
            commodityServiceId: props.strategy.id,
            havingPicFlag: 0,
            pageIndex: 1,
            pageSize: 1,
            evaluateId: props.pid,
          }).then(requiredDeep)
          props.item.childList = newParentComment.childList
          this.showChildCount.value += 1
          await $.success('评论成功，待审核通过后展示')
          this.commentContent.value = ''
          this.showCommentDialog.value = false
        })
      }

      handleContentClick = () => {
        if (props.isChildren) return
        this.showCommentDialog.value = true
      }

      handleLikeClick = () => {
        submit(async $ => {
          $.start()
          await apiEvaluationEvaluateThumbsUpOrDown({
            id: props.item.id,
          })
          props.item.totalThumbsUpCount +=
            props.item.thumbsUpFlag === 1 ? -1 : 1
          props.item.thumbsUpFlag = props.item.thumbsUpFlag === 1 ? 0 : 1
        })
      }
    },
)
